import { cookieConsentReducer } from '../../cookieConsent/reducers/CookieConsentReducer';
const loadCookieConsentModule = (initialData) => ({
    id: 'CookieConsent',
    reducerMap: {
        cookieConsent: cookieConsentReducer(initialData ? initialData.cookieConsent : []),
    },
    sagas: [],
});
export default loadCookieConsentModule;
